import React from 'react'
import Pt from 'prop-types'
import { Panel } from 'react-bootstrap'
import Ipt from 'react-immutable-proptypes'
import {connect} from "react-redux";
import {Link} from "react-router";

import Icon from 'internal-components/src/components/Icon'
import { ProductRecord } from 'internal-components/src/records'
import {makeSelectProduct} from "../../../deps/internal-components/src/redux/modules/product/selectors";

function ProductDetails({
  product,
  productId,
  qualificationLoading,
  qualificationSpeedLimitReason,
  qualificationSpeedOK,
  qualificationResults,
}) {
  if (qualificationLoading) {
    return (
      <Panel className="product-details" bsStyle="warning">
        <Panel.Body>
          <Icon size="5x" name="spinner" spin className="pull-left text-warning" />
          <p>Qualification results for your address are pending...</p>
        </Panel.Body>
      </Panel>
    )
  }

  const result = qualificationResults.getIn(
    [productId, 'available'],
    product.addressRequired ? 'needs-addr' : false,
  )
  if (result === false) {
    return null
  }

  if (result >= 1) {
    if (qualificationSpeedOK) {
      return <div>
        <Panel className="product-details" bsStyle="success">
          <Panel.Body>
            <Icon size="5x" name="thumbs-o-up" className="pull-left text-success" />
            <p>
              Service qualification has passed and this service is available at your address.
              We will run some final checks and get your order under way.
            </p>
          </Panel.Body>
        </Panel>
        {qualificationSpeedLimitReason === 'no-fibre' &&
          <Panel className="product-details" bsStyle="warning">
            <Panel.Body>
              <Icon size="5x" name="exclamation-triangle" className="pull-left text-warning"/>
              <p>
                <br />
                NBN Speeds above 100 Mbps are unavailable in your area. Only FTTP and HFC can achieve superfast speeds.
              </p>
            </Panel.Body>
          </Panel>}
        {qualificationSpeedLimitReason === 'not-civic-or-queanbeyan' &&
          <Panel className="product-details" bsStyle="warning">
            <Panel.Body>
              <Icon size="5x" name="exclamation-triangle" className="pull-left text-warning"/>
              <p>
                NBN Speeds above 250 Mbps are unavailable in your area. We only offer higher speeds for connections located in Canberra and Queanbeyan.
              </p>
            </Panel.Body>
          </Panel>}
        {qualificationSpeedLimitReason === 'no-gfast' &&
          <Panel className="product-details" bsStyle="warning">
            <Panel.Body>
              <Icon size="5x" name="exclamation-triangle" className="pull-left text-warning"/>
              <p>
                <br />
                G.fast is unavailable at your address. You can get VDSL2 at 100/40Mbit speeds.
              </p>
            </Panel.Body>
          </Panel>}
        {qualificationSpeedLimitReason === 'gfast-unsure' &&
          <Panel className="product-details" bsStyle="warning">
            <Panel.Body>
              <Icon size="5x" name="exclamation-triangle" className="pull-left text-warning"/>
              <p>
                <br />
                Plans faster than 100/40 require service qualification. If you order a faster connection, we will
                run a service qualification for your address before taking payment.
              </p>
            </Panel.Body>
          </Panel>}
      </div>
    } else {
      return (
        <Panel className="product-details" bsStyle="danger">
          <Panel.Body>
            <Icon size="5x" name="exclamation-triangle" className="pull-left text-danger" />

            <p>
              The speed you have selected is not available in your area.<br />
              Please select a different speed from the menu on the left.
            </p>
          </Panel.Body>
        </Panel>
      )
    }
  } else if (result <= -1) {
    return <Panel className="product-details" bsStyle="danger">
      <Panel.Body>
        <Icon size="5x" name="stop-circle" className="pull-left text-danger" />

        <p>
          <br />
          {product.name} is currently unavailable in your area.<br />
          Please choose a different service from the menu on the left.
        </p>
      </Panel.Body>
    </Panel>;
  } else if (result === 'needs-addr') {
    return <Panel className="product-details" bsStyle="warning">
      <Panel.Body>
        <Icon size="5x" name="map-signs" className="pull-left text-warning" />

        <p>
          These plans require you to select your address from the dropdown.<br />
          Please <Link to="/">return to the previous page</Link> and select your address from the dropdown.
        </p>
      </Panel.Body>
    </Panel>;
  }

  return (
    <Panel className="product-details" bsStyle="warning">
      <Panel.Body>
        <Icon size="5x" name="map-signs" className="pull-left text-warning" />

        <p>
          These plans require service qualification. Once you&apos;ve ordered
          but before we take your initial payment, we will run a service
          qualification to ensure that the service can be delivered to your
          address.
        </p>
      </Panel.Body>
    </Panel>
  )
}

ProductDetails.propTypes = {
  product: Pt.instanceOf(ProductRecord).isRequired,
  productId: Pt.number.isRequired,
  qualificationLoading: Pt.bool.isRequired,
  qualificationSpeedLimitReason: Pt.string.isRequired,
  qualificationSpeedOK: Pt.bool.isRequired,
  qualificationResults: Ipt.map.isRequired,
}

export const makeMapStateToProps = () => {
  const selectProduct = makeSelectProduct()

  return (state, ownProps) => ({
    product: selectProduct(state, {
      productId: ownProps.productId,
    }),
  })
}

export default connect(makeMapStateToProps)(ProductDetails)



// WEBPACK FOOTER //
// ./src/components/OfferSelector/ProductDetails.jsx